import React, {PureComponent} from "react";
import PropTypes from "prop-types";

export default class View extends PureComponent {
  static propTypes = {
    mode: PropTypes.string,
    src: PropTypes.string,
    handleClick: PropTypes.func
  };

  render() {
    const {mode, src, handleClick} = this.props;
    return (
      <div
        className={`view${mode ? ` view_${mode}` : ``}`}
        onClick={handleClick}
      >
        <img loading="lazy" src={src} className="view__img" />
      </div>
    );
  }
}
